import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ContractDetailsPage } from '@contracts';

export const Route = createFileRoute('/_app/os/contracts_/$contractId')({
  validateSearch: z.object({
    campaign: z.array(z.coerce.number()).optional().catch(undefined),
  }),
  component: ContractDetailsPage,
  pendingComponent: ContractDetailsPage.Skeleton,
  errorComponent: ContractDetailsPage.Error,
});
